const StudyOption =
    [

        {
            "id": "syllabus",
            "name": "JEE Syllabus",
            "link": "/syllabus",
            "symbol": "🗺️",
            "status": "true"
        },
       {/*
         {
            "id": "mocktest",
            "name": "JEE Mock Test",
            "link": "/quiz",
            "symbol": "📋",
            "status": "true"
        },
        */},
           {
            "id": "mocktest",
            "name": "PYQ Mock Test",
            "link": "/pyq-mock-test",
            "symbol": "📜",
            "status": "true"
        },
        {
            "id": "chapterwiseweightage",
            "name": "Chapter-wise Weightage",
            "link": "/chapter-wise-weightage",
            "symbol": "⚖️",
            "status": "true"
        },
        {
            "id": "studyplaner",
            "name": "JEE Study Planner",
            "link": "/jee-main-study-planner",
            "symbol": "🗓️",
            "status": "true"
        },
        {
            "id": "studytimetable",
            "name": "JEE Study Timetable",
            "link": "/jee-main-study-time-table",
            "symbol": "⏰",
            "status": "true"
        },
       



    ]




export default StudyOption;